export const MindscriptService = {
  evaluateExpression(expression, playbackStore) {
    log.info(3,"🔎 MindscriptService evaluateExpression", expression)
    log.info(3,"🔎 MindscriptService Current Variables", JSON.stringify(playbackStore.variables))
    // Remove {{ and }} from expression and trim whitespace from ends only
    const cleanExpr = expression.replace(/{{|}}/g, '').trim()
    
    // Split by operators while preserving operators and handling quoted strings
    const tokens = this.tokenize(cleanExpr)
    
    // Check if any token resolves to a non-numeric string (excluding undefined variables)
    const hasStringToken = tokens.some((token, index) => {
      log.info(3,"🔎 MindscriptService hasStringToken", token)
      // Skip operators
      if (token === '+' || token === '-') return false
      const value = this.resolveToken(token, playbackStore)
      const isUndefinedVariable = this.isUndefinedVariable(token, playbackStore)
      // If it's an undefined variable, don't count it as a string token for arithmetic
      if (isUndefinedVariable) return false
      return !this.isNumeric(value)
    })

    // If we have any strings, convert everything to strings and only allow concatenation
    if (hasStringToken) {
      // Start with first token
      let result = this.resolveToken(tokens[0], playbackStore)
      result = String(result)
      
      for (let i = 1; i < tokens.length; i += 2) {
        const operator = tokens[i]
        const nextToken = tokens[i + 1]
        
        if (!nextToken) continue
        
        const nextValue = this.resolveToken(nextToken, playbackStore)
        
        if (operator === '+') {
          result = result + String(nextValue)
        }
        // Ignore subtraction in string mode
      }
      return result
    } else {
      log.info(3,"🔎 MindscriptService numeric mode")
      // All tokens are numeric, do math operations
      // Start with first token, convert undefined variables to 0
      let result
      if (this.isUndefinedVariable(tokens[0], playbackStore)) {
        result = 0
        log.info(3,"🔎 First token is undefined variable, setting to 0")
      } else {
        const firstValue = this.resolveToken(tokens[0], playbackStore)
        result = Number(firstValue)
        log.info(3,"🔎 First token resolved to:", firstValue, "converted to number:", result)
      }
      
      for (let i = 1; i < tokens.length; i += 2) {
        const operator = tokens[i]
        const nextToken = tokens[i + 1]
        
        if (!nextToken) continue
        
        let nextValue
        if (this.isUndefinedVariable(nextToken, playbackStore)) {
          nextValue = 0
          log.info(3,"🔎 Token", nextToken, "is undefined variable, using 0")
        } else {
          const resolvedValue = this.resolveToken(nextToken, playbackStore)
          nextValue = Number(resolvedValue)
          log.info(3,"🔎 Token", nextToken, "resolved to:", resolvedValue, "converted to number:", nextValue)
        }
        
        if (operator === '+') {
          log.info(3,"🔎 Adding:", result, "+", nextValue)
          result += nextValue
        } else if (operator === '-') {
          log.info(3,"🔎 Subtracting:", result, "-", nextValue)
          result -= nextValue
        }
        log.info(3,"🔎 Result after operation:", result)
      }
      return result
    }
    
    return result
  },
  
  tokenize(expr) {
    const tokens = []
    let current = ''
    let inQuotes = false
    
    for (let i = 0; i < expr.length; i++) {
      const char = expr[i]
      
      if (char === '"') {
        inQuotes = !inQuotes
        current += char
      } else if ((char === '+' || char === '-') && !inQuotes) {
        if (current.trim()) {
          tokens.push(current.trim())
        }
        tokens.push(char)
        current = ''
      } else {
        current += char
      }
    }
    
    if (current.trim()) {
      tokens.push(current.trim())
    }
    
    return tokens
  },
  
  resolveToken(token, playbackStore) {
    token = token.trim()
    
    // Check if token is a quoted string
    if (token.startsWith('"') && token.endsWith('"')) {
      return token.slice(1, -1)  // Remove quotes but preserve internal spaces
    } else if (token.startsWith("'") && token.endsWith("'")) {
      return token.slice(1, -1)  // Remove quotes but preserve internal spaces
    }
    
    // Check if token is a number literal
    if (this.isNumeric(token)) {
      log.info(3,"🔎 MindscriptService resolveToken", token, token, "(numeric literal)")
      return token
    }
    
    // If it's a variable name, get its value
    const value = playbackStore.getVariable(token)
    log.info(3,"🔎 MindscriptService resolveToken", token, value)
    if (value !== undefined) {
      return value
    }
    
    // If variable doesn't exist, return the token name itself
    return token
  },

  // New helper method to check if a token is an undefined variable
  isUndefinedVariable(token, playbackStore) {
    token = token.trim()
    
    // Skip quoted strings - they're not variables
    if ((token.startsWith('"') && token.endsWith('"')) || 
        (token.startsWith("'") && token.endsWith("'"))) {
      return false
    }
    
    // Skip numeric literals - they're not variables
    if (this.isNumeric(token)) {
      return false
    }
    
    // Check if the variable is undefined
    const value = playbackStore.getVariable(token)
    return value === undefined
  },

  isNumeric(value) {
    // Handle empty values
    if (!value && value !== 0) return false
    
    // Handle already-numeric values
    if (typeof value === 'number') return true
    
    // Handle string values that can be converted to numbers
    if (typeof value === 'string') {
      // Remove whitespace
      const trimmed = value.trim()
      // Check if it can be converted to a number and is not empty
      return trimmed !== '' && !isNaN(trimmed)
    }
    
    return false
  }
}